export const PerformanceActionTypes = {
    LOGOUT: 'LOGOUT',
    COMMON_ERROR: 'COMMON_ERROR',

    PEFORMANCE_NEW_REQUEST: 'PEFORMANCE_NEW_REQUEST',
    PEFORMANCE_NEW_REQUEST_SUCCESS: 'PEFORMANCE_NEW_REQUEST_SUCCESS',
    PEFORMANCE_NEW_REQUEST_ERROR: 'PEFORMANCE_NEW_REQUEST_ERROR',
    PEFORMANCE_NEW_REQUEST_STATUS: 'PEFORMANCE_NEW_REQUEST_STATUS',

    PEFORMANCE_REQUEST_LIST_REQUEST: 'PEFORMANCE_REQUEST_LIST_REQUEST',
    PEFORMANCE_REQUEST_LIST_REQUEST_SUCCESS: 'PEFORMANCE_REQUEST_LIST_REQUEST_SUCCESS',
    PEFORMANCE_REQUEST_LIST_REQUEST_ERROR: 'PEFORMANCE_REQUEST_LIST_REQUEST_ERROR',

    PERFORMANCE_NEW_REVIEW_REQUEST: 'PERFORMANCE_NEW_REVIEW_REQUEST',
    PERFORMANCE_NEW_REVIEW_REQUEST_SUCCESS: 'PERFORMANCE_NEW_REVIEW_REQUEST_SUCCESS',
    PERFORMANCE_NEW_REVIEW_REQUEST_ERROR: 'PERFORMANCE_NEW_REVIEW_REQUEST_ERROR',
    PERFORMANCE_NEW_REVIEW_REQUEST_STATUS: 'PERFORMANCE_NEW_REVIEW_REQUEST_STATUS',

    PEFORMANCE_REVIEW_LIST_REQUEST: 'PEFORMANCE_REVIEW_LIST_REQUEST',
    PEFORMANCE_REVIEW_LIST_REQUEST_SUCCESS: 'PEFORMANCE_REVIEW_LIST_REQUEST_SUCCESS',
    PEFORMANCE_REVIEW_LIST_REQUEST_ERROR: 'PEFORMANCE_REVIEW_LIST_REQUEST_ERROR',

    PEFORMANCE_NEW_GOAL_REQUEST: 'PEFORMANCE_NEW_GOAL_REQUEST',
    PEFORMANCE_NEW_GOAL_REQUEST_SUCCESS: 'PEFORMANCE_NEW_GOAL_REQUEST_SUCCESS',
    PEFORMANCE_NEW_GOAL_REQUEST_ERROR: 'PEFORMANCE_NEW_GOAL_REQUEST_ERROR',
    PEFORMANCE_NEW_GOAL_REQUEST_STATUS: 'PEFORMANCE_NEW_GOAL_REQUEST_STATUS',

    PEFORMANCE_GOAL_LIST_REQUEST: 'PEFORMANCE_GOAL_LIST_REQUEST',
    PEFORMANCE_GOAL_LIST_REQUEST_SUCCESS: 'PEFORMANCE_GOAL_LIST_REQUEST_SUCCESS',
    PEFORMANCE_GOAL_LIST_REQUEST_ERROR: 'PEFORMANCE_GOAL_LIST_REQUEST_ERROR',

    PEFORMANCE_GOAL_DETAILS_REQUEST: 'PEFORMANCE_GOAL_DETAILS_REQUEST',
    PEFORMANCE_GOAL_DETAILS_REQUEST_SUCCESS: 'PEFORMANCE_GOAL_DETAILS_REQUEST_SUCCESS',
    PEFORMANCE_GOAL_DETAILS_REQUEST_ERROR: 'PEFORMANCE_GOAL_DETAILS_REQUEST_ERROR',

    PEFORMANCE_ADD_GOAL_COMMENT_REQUEST: 'PEFORMANCE_ADD_GOAL_COMMENT_REQUEST',
    PEFORMANCE_ADD_GOAL_COMMENT_REQUEST_SUCCESS: 'PEFORMANCE_ADD_GOAL_COMMENT_REQUEST_SUCCESS',
    PEFORMANCE_ADD_GOAL_COMMENT_REQUEST_ERROR: 'PEFORMANCE_ADD_GOAL_COMMENT_REQUEST_ERROR',
    PEFORMANCE_ADD_GOAL_COMMENT_REQUEST_STATUS: 'PEFORMANCE_ADD_GOAL_COMMENT_REQUEST_STATUS',

    PEFORMANCE_UPDATE_GOAL_REQUEST: 'PEFORMANCE_UPDATE_GOAL_REQUEST',
    PEFORMANCE_UPDATE_GOAL_REQUEST_SUCCESS: 'PEFORMANCE_UPDATE_GOAL_REQUEST_SUCCESS',
    PEFORMANCE_UPDATE_GOAL_REQUEST_ERROR: 'PEFORMANCE_UPDATE_GOAL_REQUEST_ERROR',
    PEFORMANCE_UPDATE_GOAL_REQUEST_STATUS: 'PEFORMANCE_UPDATE_GOAL_REQUEST_STATUS'
}
